import { FC } from "react";
import styles from "./Icon.module.scss";
import cn from "classnames";

interface Props {
    type: "Success" | "Error" | "Warning" | "Key" | "Pending";
}

const Icon: FC<Props> = ({ type }) => {
    return (
        <div className={cn(styles.icon, styles[type.toLowerCase()])}>
            <img height={24} width={24} src={`/images/modal/${type.toLowerCase()}.svg`} alt="" />
        </div>
    );
};

export default Icon;
